import React, { PureComponent } from 'react';
import { Col, Form } from 'react-bootstrap';
import { Shapes } from '../../../models/entities';

class BptHealthReportForm extends PureComponent {
  constructor(props) {
    super(props);

    const { bptHealthReport } = props;
    if (bptHealthReport) {
      this.state = { ...bptHealthReport };
    } else {
      this.state = {
        terminal: '',
        printerStatus: '',
        cashAcceptorStatus: '',
        emvReaderStatus: '',
        billScannerStatus: '',
        digitalIoStatus: '',
        allKioskAvailable: false,
        kpsAvailable: false,
        receivedAt: '',
        date: '',
        time: '',
      };
    }
  }

  render = () => {
    const {
      terminal, printerStatus, cashAcceptorStatus, emvReaderStatus,
      billScannerStatus, digitalIoStatus, allKioskAvailable,
      kpsAvailable, receivedAt, date, time,
    } = this.state;

    return (
      <Form noValidate>
        <Form.Row>
          <Col>
            <Form.Group controlId="name">
              <Form.Label>Terminal</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={terminal.name}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="printerStatus">
              <Form.Label>Printer Status</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={printerStatus || '-'}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="cashAcceptorStatus">
              <Form.Label>Cash Acceptor Status</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={cashAcceptorStatus || '-'}
              />
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="emvReaderStatus">
              <Form.Label>EMV Reader Status</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={emvReaderStatus || '-'}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="billScannerStatus">
              <Form.Label>Bill Scanner Status</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={billScannerStatus || '-'}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="digitalIoStatus">
              <Form.Label>Digital IO Status</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={digitalIoStatus || '-'}
              />
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="allKioskAvailable">
              <Form.Check
                disabled
                checked={allKioskAvailable}
                type="checkbox"
                label="AllKiosk Available"
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="kpsAvailable">
              <Form.Check
                disabled
                checked={kpsAvailable}
                type="checkbox"
                label="KPS Available"
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="receivedAt">
              <Form.Label>Received At</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={receivedAt}
              />
            </Form.Group>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Group controlId="date">
              <Form.Label>Date</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={date}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group controlId="time">
              <Form.Label>Time</Form.Label>
              <Form.Control
                readOnly
                type="text"
                value={time}
              />
            </Form.Group>
          </Col>
        </Form.Row>
      </Form>
    );
  }
}

BptHealthReportForm.propTypes = {
  bptHealthReport: Shapes.BPT_HEALTH_REPORT,
};

BptHealthReportForm.defaultProps = {
  bptHealthReport: null,
};

export default BptHealthReportForm;
